import type { RouteRecordRaw } from 'vue-router'

// Ers 子系统（独立 H5 设备绑定流程：中转 → 登录 → home/guide → 绑定）
export const ersRoutes: RouteRecordRaw[] = [
  {
    // 入口中转页（无 token→login，有 token→home/guide）
    path: '/ers',
    name: 'ers-entry',
    component: () => import('@/pages/Web/Ers/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 登录页（国内手机验证码）
    path: '/ers/login',
    name: 'ers-login',
    component: () => import('@/pages/Web/Ers/Login/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 引导页（无设备时落地）
    path: '/ers/guide',
    name: 'ers-guide',
    component: () => import('@/pages/Web/Ers/Guide/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 设备主页
    path: '/ers/home',
    name: 'ers-home',
    component: () => import('@/pages/Web/Ers/Home/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 选择产品添加设备
    path: '/ers/add-device',
    name: 'ers-add-device',
    component: () => import('@/pages/Web/Ers/AddDevice/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 选择 / 新建孩子子账号
    path: '/ers/bind-sub-user',
    name: 'ers-bind-sub-user',
    component: () => import('@/pages/Web/Ers/BindSubUser/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 设备开机引导
    path: '/ers/bind-device',
    name: 'ers-bind-device',
    component: () => import('@/pages/Web/Ers/BindDevice/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 配对码输入
    path: '/ers/pair-code',
    name: 'ers-pair-code',
    component: () => import('@/pages/Web/Ers/PairCode/index.vue'),
    meta: { backMode: 'allow' },
  },
]
